import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const convertToUserTimezone = (date, format = 'MMM DD, YYYY HH:mm') => {
  if (date == null || date === '') return '';

  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let parsedDate = date;

  if (typeof date === 'number' || (typeof date === 'string' && !isNaN(date))) {
    const num = Number(date);
    // If the timestamp is larger than 1e12 (1 billion), it's already in milliseconds.
    // Otherwise, it's in seconds and needs to be converted to milliseconds.
    parsedDate = num > 1e12 ? num : num * 1000;
  }

  return dayjs(parsedDate).tz(userTimezone).format(format);
};
